import React, { useState } from 'react';
import { ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'basico'>('completo');
  const checkoutBasico = 'https://argentina.recursodigital.shop/cart/48803820732635:1';
  const checkoutCompleto = 'https://argentina.recursodigital.shop/cart/48803821093083:1';
  return <section id="oferta" className="bg-[#0B0B12] pt-16 pb-6 px-5 scroll-mt-10 relative overflow-hidden" data-id="element-190">
      <div className="blur-circle bg-brand-navy/30 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-20" data-id="element-191" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-192">
        <div className="text-center mb-10" data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-194">
            Elegí tu{' '}
            <span className="gold-text-gradient" data-id="element-195">sistema profesional:</span>
          </h2>
          <p className="text-sm text-slate-400 font-bold uppercase tracking-widest" data-id="element-196">
            Las dos opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        <button onClick={() => setSelected('basico')} className={`w-full text-left bg-white/5 backdrop-blur-md rounded-2xl p-6 mb-4 border-2 transition-all shadow-2xl ${selected === 'basico' ? 'border-brand-gold ring-4 ring-brand-gold/10' : 'border-white/10 hover:border-white/20'}`} data-id="element-197">
          <div className="flex items-start gap-4" data-id="element-198">
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-1 flex items-center justify-center ${selected === 'basico' ? 'border-brand-gold' : 'border-white/20'}`} data-id="element-199">
              {selected === 'basico' && <div className="w-3 h-3 rounded-full bg-brand-gold shadow-[0_0_10px_rgba(212,176,106,0.5)]" data-id="element-200" />}
            </div>
            <div className="flex-grow min-w-0" data-id="element-201">
              <div className="flex items-start justify-between gap-4 mb-1" data-id="element-202">
                <div className="flex items-center gap-2" data-id="element-203">
                  <span className="text-xl flex-shrink-0" data-id="element-204">📘</span>
                  <h4 className="text-base font-black text-white uppercase leading-tight tracking-tight" data-id="element-205">
                    MEGAPACK PELUQUERÍA LISTA™
                  </h4>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-206">
                  <div className="text-[10px] text-slate-500 line-through font-bold" data-id="element-207">
                    $27.990 ARS
                  </div>
                  <div className="text-xl font-black text-white leading-none" data-id="element-208">
                    $19.990
                  </div>
                </div>
              </div>
              <p className="text-sm text-slate-400 font-bold uppercase tracking-wider" data-id="element-209">
                6 tomos + 6 bonos
              </p>
            </div>
          </div>
        </button>

        <button onClick={() => setSelected('completo')} className={`w-full text-left bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-md rounded-2xl p-6 relative border-2 transition-all shadow-2xl ${selected === 'completo' ? 'border-brand-gold ring-4 ring-brand-gold/10' : 'border-white/10 hover:border-white/20'}`} data-id="element-210">
          <div className="flex items-start gap-4" data-id="element-211">
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-1 flex items-center justify-center ${selected === 'completo' ? 'border-brand-gold' : 'border-white/20'}`} data-id="element-212">
              {selected === 'completo' && <div className="w-3 h-3 rounded-full bg-brand-gold shadow-[0_0_10px_rgba(212,176,106,0.5)]" data-id="element-213" />}
            </div>
            <div className="flex-grow min-w-0" data-id="element-214">
              <div className="flex items-start justify-between gap-4 mb-2" data-id="element-215">
                <div className="flex items-center gap-2" data-id="element-216">
                  <span className="text-xl flex-shrink-0" data-id="element-217">🏆</span>
                  <h4 className="text-base font-black gold-text-gradient uppercase leading-tight tracking-tight" data-id="element-218">
                    MEGAPACK + KIT DE IMPLEMENTACIÓN PROFESIONAL™
                  </h4>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-219">
                  <div className="text-[10px] text-slate-500 line-through font-bold" data-id="element-220">
                    $49.990 ARS
                  </div>
                  <div className="text-xl font-black text-white leading-none" data-id="element-221">
                    $27.990
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-2 mb-3" data-id="element-222">
                <span className="bg-brand-gold text-black text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-223">
                  ⭐ MÁS ELEGIDO
                </span>
                <span className="bg-green-500/20 text-green-400 border border-green-500/30 text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-224">
                  AHORRÁS MÁS DE $20.000
                </span>
              </div>
              <p className="text-sm text-slate-300 font-black uppercase tracking-tight leading-tight" data-id="element-225">
                6 tomos + 6 bonos + sistema completo de implementación
              </p>
            </div>
          </div>
        </button>

        <a href={selected === 'completo' ? checkoutCompleto : checkoutBasico} className="block w-full btn-premium md:text-xl py-[20px] px-[36px] rounded-[20px] transition-all hover:scale-[1.02] text-center mt-10 mb-8 no-underline text-[14px]" data-id="element-226">
          {selected === 'completo' ? 'SÍ, QUIERO TODO EL SISTEMA →' : 'QUIERO MI MEGAPACK AHORA →'}
        </a>

        <div className="border border-slate-100 rounded-2xl py-6 px-6 shadow-sm bg-[#303030]" data-id="element-227">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-4 text-xs font-bold text-slate-500" data-id="element-228">
            <div className="flex items-center gap-2 text-[#CCCBCB]" data-id="element-229">
              <Lock size={16} className="text-brand-primary" data-id="element-230" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2 text-[#CCCBCB]" data-id="element-231">
              <Zap size={16} className="text-brand-primary" data-id="element-232" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2 text-[#CCCBCB]" data-id="element-233">
              <ShieldCheck size={16} className="text-brand-primary" data-id="element-234" />
              Garantía 7 días
            </div>
          </div>
          <div className="flex items-center justify-center gap-3 mt-6 pt-6 border-t border-slate-50" data-id="element-235">
            <CreditCard size={18} className="text-brand-primary flex-shrink-0" data-id="element-236" />
            <span className="text-xs font-bold text-center text-[#CCCBCB]" data-id="element-237">
              Pagá con tarjeta o MercadoPago de forma segura y accedé al
              material HOY
            </span>
          </div>
        </div>
      </div>
    </section>;
}